export default __webpack_public_path__ + "static/media/footer_pc@2x.bdfe5d1b.jpg";